"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.body = exports.headerRow = void 0;

var _react = require("@emotion/react");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  tr {\n    td {\n      font-size: 1em;\n      border: unset;\n      padding: 8px;\n      color: ", ";\n    }\n    td:first-of-type {\n      color: ", ";\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  th {\n    border: unset;\n    padding: 16px 8px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var headerRow = function headerRow() {
  return (0, _react.css)(_templateObject());
};

exports.headerRow = headerRow;

var body = function body(theme) {
  return (0, _react.css)(_templateObject2(), theme.colors.neutral[500], theme.colors.primary);
};

exports.body = body;